import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Document, Page } from 'react-pdf';

import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import { Tooltip, TooltipTypes } from 'components/admin/Help';
import { generateInvoicePDF } from '../../../store/generators';
import { startEditPreview } from '../../../store/actions/preview';

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flexGrow: 1,
  },
  sendTo: {
    marginBottom: theme.spacing.unit*4,
  },
  document: {
    marginTop: theme.spacing.unit*2,
  }
});

class SendInvoice extends Component {
  state = {
    numPages: null,
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  }

  render() {
    const { numPages } = this.state;
    const {
      classes,
      blob,
      toEmail,
      ccEmail,
      note,
      preview,
      startEditPreview
    } = this.props;

    return(
      <div className={classes.root}>
        <Tooltip type={TooltipTypes.INVOICE_SEND_EMAIL} placement="bottom">
          <TextField
            id="full-width"
            label="To"
            value={toEmail}
            onChange={event => {
              preview.data.toEmail = event.target.value;
              startEditPreview(preview);
            }}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Enter email"
            margin="normal"
            fullWidth
          />
        </Tooltip>
        <TextField
          id="full-width"
          label="CC"
          value={ccEmail}
          onChange={event => {
            preview.data.ccEmail = event.target.value;
            startEditPreview(preview);
          }}
          InputLabelProps={{
            shrink: true,
          }}
          placeholder="Carbon Copy Email"
          margin="normal"
          fullWidth
        />
        <TextField
          id="full-width"
          label="Note"
          value={note}
          onChange={event => {
            preview.data.note = event.target.value;
            startEditPreview(preview);
          }}
          InputLabelProps={{
            shrink: true,
          }}
          placeholder="Enter Note"
          margin="normal"
          multiline={true}
          rows={3}
          fullWidth
        />
        <Document
          className={classes.document}
          file={blob}
          onLoadSuccess={this.onDocumentLoad}
        >
          {
            Array.from(
              new Array(numPages),
              (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                />
              ),
            )
          }
        </Document>
      </div>
    );
  }
};

const mapStateToProps = (state, props) => {
  const preview = state.previewState;
  const toEmail = preview.data.toEmail;
  const ccEmail = preview.data.ccEmail;
  const note = preview.data.note;
  const blob = preview.data.blob;

  return({
      preview,
      blob,
      toEmail,
      ccEmail,
      note
  });
}

const mapDispatchToProps = {
  startEditPreview,
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(SendInvoice);



// WEBPACK FOOTER //
// ./src/components/admin/Preview/SendPreview.jsx